exports.getZipObjUhcRenewals = (renewalCaseData) => {
    return {
        zipCode: renewalCaseData ? renewalCaseData.zipCode : "",
        city: renewalCaseData.city ? renewalCaseData.city : "",
        stateCode: renewalCaseData ? renewalCaseData.situsState : "",
        county: renewalCaseData.county ? renewalCaseData.county : "",
        countyFIPSCode: renewalCaseData.county ? renewalCaseData.county.slice(-3) : " "
    }
}